import { NgClass, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
 selector: 'iho-pagination',
 templateUrl: './pagination.component.html',
 styleUrls: ['./pagination.component.scss'],
 standalone: true,
 imports: [NgFor, NgClass],
})
export class PaginationComponent implements OnInit {
 @Input() count = 0;
 @Input() perPageItems = 24;
 @Input() currentPage = 1;
 @Output() paginate = new EventEmitter<number>();
 minimumShowingItems = 3;
 pages: string[] = [];

 
   ngOnInit(): void {
      this.arrangePagination()
   }

 arrangePagination() {
    this.pages = []
    this.pages.push('1');

    if (this.count <= this.perPageItems) {
      this.currentPage = 1
      return
    }

  if (this.currentPage > this.minimumShowingItems) {
    this.pages.push('...')
  }

  if (this.currentPage > 1) {
   const prevPage = this.currentPage - 1 === 1 ? 2 : this.currentPage - 1;
   this.pages.push(String(prevPage));
  }

  if (this.currentPage >= this.minimumShowingItems) {
   this.pages.push(String(this.currentPage));
  }

  const lastPage = Math.ceil(this.count / this.perPageItems);
  
  
  const nextPage = this.currentPage + 1;
  if (nextPage !== lastPage && this.currentPage !== lastPage) {
   this.pages.push(String(nextPage));
   if (lastPage > 4 && (nextPage) < this.minimumShowingItems) {
    this.pages.push(String(nextPage + 1));
   }

   if (nextPage - 1 < this.count / this.perPageItems - this.minimumShowingItems) {
    this.pages.push('...');
   } else {
    if (nextPage + 1 < lastPage) {
     this.pages.push(String(nextPage + 1));
    }
    if (nextPage + 2 < lastPage) {
     this.pages.push(String(nextPage + 2));
    }
   }
  }

  if (this.currentPage !== lastPage) {
      this.pages.push(String(lastPage));
  }

 }

 onPageChange(page: string) {
  const lastPage = Math.ceil(this.count / this.perPageItems);
    if (page !== '...' && (+page > 0) && (+page <= lastPage)) {
      this.currentPage = +page
      this.arrangePagination()
      this.paginate.emit(this.currentPage)
    }
 }
 
}
